
    var content = require("!!../../../../../gl-commons/react-app-scripts/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../gl-commons/react-app-scripts/node_modules/postcss-loader/src/index.js??postcss!../../../../../gl-commons/react-app-scripts/node_modules/sass-loader/lib/loader.js??ref--7-3!./VerticalProfileNavigationBar.scss");
    var insertCss = require("!../../../../../gl-commons/react-app-scripts/node_modules/isomorphic-style-loader/lib/insertCss.js");

    if (typeof content === 'string') {
      content = [[module.id, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (module.hot && typeof window !== 'undefined' && window.document) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../../gl-commons/react-app-scripts/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../gl-commons/react-app-scripts/node_modules/postcss-loader/src/index.js??postcss!../../../../../gl-commons/react-app-scripts/node_modules/sass-loader/lib/loader.js??ref--7-3!./VerticalProfileNavigationBar.scss", function() {
        content = require("!!../../../../../gl-commons/react-app-scripts/node_modules/css-loader/dist/cjs.js??ref--7-1!../../../../../gl-commons/react-app-scripts/node_modules/postcss-loader/src/index.js??postcss!../../../../../gl-commons/react-app-scripts/node_modules/sass-loader/lib/loader.js??ref--7-3!./VerticalProfileNavigationBar.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  